import { Helper } from '../../Helper';
export class InstanceofHelper extends Helper {
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            sb.emitOp(node, 'DROP');
            return;
        }
        sb.emitPushString(node, 'prototype');
        sb.emitHelper(node, options, sb.helpers.getPropertyObjectProperty);
        sb.emitOp(node, 'SWAP');
        const prepareLoop = () => {
            sb.emitOp(node, 'DUP');
            sb.emitPushString(node, '__proto__');
            sb.emitHelper(node, options, sb.helpers.getPropertyObjectProperty);
            sb.emitOp(node, 'DUP');
            sb.emitOp(node, 'ROT');
            sb.emitPushInt(node, 3);
            sb.emitOp(node, 'PICK');
        };
        prepareLoop();
        sb.emitHelper(node, options, sb.helpers.forLoop({
            condition: () => {
                sb.emitOp(node, 'EQUAL');
                sb.emitOp(node, 'DUP');
                sb.emitOp(node, 'NOT');
                sb.emitOp(node, 'ROT');
                sb.emitHelper(node, options, sb.helpers.isUndefined);
                sb.emitOp(node, 'NOT');
                sb.emitOp(node, 'BOOLAND');
            },
            each: () => {
                sb.emitOp(node, 'DROP');
                prepareLoop();
            },
            cleanup: () => {
            },
        }));
        sb.emitOp(node, 'NIP');
        sb.emitOp(node, 'NIP');
    }
}

//# sourceMappingURL=InstanceofHelper.js.map
